import React  from 'react';
import styled from 'styled-components';
const Styles = styled.div`

`
export default function Default (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  // console.log('aasssdddd')
  // console.log('<<<<<<' + data)
  return (
    <Styles>
      {data.Continent_Id}
    </Styles>
  )
}

